/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Faq_First_Task_AnswerInputs */

const en_faq_first_task_answer = /** @type {(inputs: Faq_First_Task_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something worth real time or money with a clear result: the replies your team writes every day, leads nobody has time to research, a report that takes a day to gather, or a process you’d like a system to run. One recent example is enough to start a useful conversation.`)
};

const lv_faq_first_task_answer = /** @type {(inputs: Faq_First_Task_AnswerInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ar ko tādu, kas maksā īstu laiku vai naudu un kam ir skaidrs rezultāts: atbildes, ko komanda raksta katru dienu, potenciālie klienti, kurus nav laika izpētīt, atskaite, kuras sagatavošana aizņem dienu, vai process, ko gribētu uzticēt sistēmai. Viens nesens piemērs ir pietiekams, lai sāktu noderīgu sarunu.`)
};

/**
* | output |
* | --- |
* | "Something worth real time or money with a clear result: the replies your team writes every day, leads nobody has time to research, a report that takes a day ..." |
*
* @param {Faq_First_Task_AnswerInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const faq_first_task_answer = /** @type {((inputs?: Faq_First_Task_AnswerInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Faq_First_Task_AnswerInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_faq_first_task_answer(inputs)
	return en_faq_first_task_answer(inputs)
});